export default __webpack_public_path__ + "static/media/mg.ed51bbfa.webp";